<template>
  <el-table class="list" id="listServers" :data="sip_servers">
    <el-table-column prop="ip" label="IP-адрес">
      <template slot-scope="scope">
        <router-link class="link" :to="'/sip-server/edit/' + scope.row.id_sip_server">
          {{ scope.row.ip || "Нет данных" }}
        </router-link>
      </template>
    </el-table-column>
    <el-table-column prop="port_service" label="Порт сервиса управления конфигурациями" />
    <el-table-column prop="port_intercom" label="Порт для домофонов"  />
    <el-table-column prop="port_client_device" label="Порт для устройств" />
    <el-table-column prop="intercoms_count" label="Количество домофонов" />
    <el-table-column align="center" width="120px" v-if="$can('delete', 'sip-servers')" label="Действия">
      <template slot-scope="scope">
        <el-button size="small" type="danger" @click="onRemove(scope.row.id_sip_server)">
          Удалить <fa :icon="['fas', 'trash-alt']" />
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { FontAwesomeIcon as fa } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { mapActions, mapState } from "vuex";

library.add(faTrashAlt);

export default {
  name: "ServersTable",
  components: { fa },
  computed: {
    ...mapState("sip_servers", {
      sip_servers: (state) => state.data,
    }),
  },
  methods: {
    ...mapActions("sip_server", {
      deleteServer: "DELETE_SIP_SERVER",
    }),
    onRemove(id) {
      const server = this.sip_servers.find((c) => c.id_sip_server === id);
      this.$confirm(`Вы точно хотите удалить SIP-сервер ${server.ip} ?`, "Подтверждение", {
        confirmButtonText: "Удалить",
        cancelButtonText: "Отменить",
        confirmButtonClass: "el-button--danger",
        type: "warning",
      }).then(() => this.remove(id));
    },
    remove(id) {
      this.deleteServer(id)
        .then(() => {
          this.$message({
            message: "SIP-сервер удален",
            type: "success",
          });
          this.$emit("serverDeleted");
        })
        .catch((e) => {
          this.$message.error(e.response.data.error || "Ошибка при удалении SIP-сервера");
        });
    },
  },
};
</script>
